/**
 * AI Helpers Utilities - Shared functions and hooks for AI helper components
 */
import { useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

// Helper function to extract error message from API response
export const getErrorMessage = (error, defaultMsg) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail) && detail.length > 0) {
    return detail[0]?.msg || defaultMsg;
  }
  if (typeof detail === 'object' && detail?.msg) {
    return detail.msg;
  }
  return defaultMsg;
};

// Ensure value is a string
export const safeString = (value, fallback = '') => {
  return typeof value === 'string' ? value : String(value || fallback);
};

// Custom hook for AI generation
export const useAIGeneration = (endpoint) => {
  const [loading, setLoading] = useState(false);
  const [generatedText, setGeneratedText] = useState('');
  const [copied, setCopied] = useState(false);
  
  const token = localStorage.getItem('token');
  
  const generate = useCallback(async (payload) => {
    setLoading(true);
    try {
      const response = await axios.post(`${API}/ai-assistant/${endpoint}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  }, [endpoint, token]);
  
  const handleCopy = useCallback((text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    toast.success('Copied to clipboard');
  }, []);
  
  const reset = useCallback(() => {
    setGeneratedText('');
    setCopied(false);
  }, []);
  
  return {
    loading,
    generatedText,
    setGeneratedText,
    copied,
    generate,
    handleCopy,
    reset
  };
};
